import { SortFilter } from './sortFilter';

export class SearchSortFilter extends SortFilter {
  searchQuery: string | null;

  constructor() {
    super();
  }
}
